import PropTypes from "prop-types";

import React, { Component, useState } from "react";

import { Link } from "react-router-dom";
import { connect } from "react-redux";

//Verification code package
import AuthCode from "react-auth-code-input";
import { loginApiError, verify2fLogin, sendVerificationCode } from "../../store/actions";
import { withTranslation } from "react-i18next";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Row,
  Alert
} from "reactstrap";

import { TimerCounter } from "../../components/Common/CombinedComponents";
let trys = false;
class TwostepVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sixDigit: "",
      minutes: "",
      seconds: "",
      isSendAgain: false,
      record: {
        message: "",
        code: "",
        details: "",
        correlationId: "",
        validationResults: [],
      },
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.handleSendSmsAgain = this.handleSendSmsAgain.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleTimeUpdate = this.handleTimeUpdate.bind(this);
  }

  componentDidMount = () => {
    this.props.loginApiError("");
    this.setState({ sixDigit: "" });
    this.props.sendVerificationCode(this.props.history);
    document.addEventListener(
      "keydown",
      e =>
        (e.code === "Enter" || e.code === "NumpadEnter") &&
        this.state.sixDigit.length == 6 &&
        this.handleValidSubmit(),
    );
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { error } = this.props;
    const { record, sixDigit, minutes, seconds } = this.state;

    if (prevProps.error !== error) {
      if (error) {
        if (error.response && error.response.data != '') {
          let a = JSON.parse(error.response.data);
          record.code = a.Code;
          record.message = a.Message;
        }
        else if (error) {
          record.code = error.code;
          record.message = error.message;
        } else {
          record.code = "Unhandled Exeption";
          record.message = "Please contact with Administrator";
        }
        this.setState({ error: record });
      }

    }
    if (prevState.sixDigit !== sixDigit) {
      this.setState({ sixDigit: sixDigit });
    }
  }

  handleValidSubmit(event, values) {
    const verify = {
      verificationCode: this.state.sixDigit,
      twoFactorSecret: "",
    };
    this.props.verify2fLogin(verify, this.props.history);
  }

  handleSendSmsAgain() {
    this.props.sendVerificationCode(this.props.history);
    this.setState({ isSendAgain: false });
  }


  handleOnChange = res => {
    this.setState({ sixDigit: res });
  };

  handleTimeUpdate = (newMinutes, newSeconds) => {
    this.setState({ minutes: newMinutes });
    this.setState({ seconds: newSeconds });

    if (newMinutes == "00" && newSeconds == "00") {
      this.setState({ isSendAgain: true });
      this.setState({ sixDigit: "" });
    }
  };

  render() {
    const { minutes, seconds, isSendAgain } = this.state;
    return (
      <React.Fragment>
        <div className="account-pages my-5 pt-sm-5" style={{ color: "white" }}>
          <title>{this.props.t("smsVerificationCode")}</title>

          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card>
                  <CardBody >
                    <div className="p-2">
                      <div className="text-center">
                        <div className="avatar-md mx-auto">
                          <div className="avatar-title rounded-circle bg-light">
                            <i className="bx bxs-key h1 mb-0 text-primary"></i>
                          </div>
                        </div>
                        <div className="p-2 mt-4">
                          <h4>{this.props.t("smsVerificationCode")}</h4>
                          <br />
                          <br />
                          <p className="mb-5">
                            <span className="font-weight-semibold">
                              {this.props.t(
                                "enterThe6DigitVerificationCodeWeSentTo",
                              )}{" "}
                              {localStorage.getItem("phone")}{" "}
                            </span>
                          </p>
                          <div className="p-2">
                            {this.state.error ? (
                              <Alert color="danger">
                                {this.props.t([this.state.error.message])}
                              </Alert>
                            ) : null}
                          </div>
                          <Form>
                            <Row>
                              <Col xs={12}>
                                <FormGroup className="verification">
                                  <label
                                    htmlFor="digit1-input"
                                    className="sr-only"
                                  >
                                    Dight 1
                                  </label>
                                  <AuthCode
                                    characters={6}
                                    onChange={this.handleOnChange}
                                    name="sixDigit"
                                    allowedCharacters="numeric"
                                    value={this.state.sixDigit}
                                    inputClassName="authInput"

                                  />
                                </FormGroup>

                                <Col style={{
                                  textAlign: "left",
                                  paddingLeft: 20,
                                  paddingTop: 15,
                                }}>
                                  <div>
                                    <TimerCounter onTimeUpdate={this.handleTimeUpdate} />
                                    <div>{minutes}:{seconds}</div>
                                  </div>
                                </Col>
                              </Col>
                            </Row>
                          </Form>

                          <div className="mt-4">
                            <button
                              className="btn btn-backgroundColor btn-block"
                              onClick={this.handleValidSubmit}
                              disabled={isSendAgain}
                              style={{ backgroundColor: "#AB63BF", color: "#FAF3FD" }}
                            >
                              {this.props.t("confirm")}
                            </button>
                          </div>
                          <div className="mt-4">
                            <button
                              className={!isSendAgain ? "btn btn-backgroundColor" : "btn btn-primary"}
                              onClick={this.handleSendSmsAgain}
                            >
                              {this.props.t("sendAgain")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center"></div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

TwostepVerification.propTypes = {
  loginApiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  verify2fLogin: PropTypes.func,
  sendVerificationCode: PropTypes.func,
  t: PropTypes.any,
};

const mapStateToProps = state => {
  const { loginApiError, error } = state.Login;
  return { loginApiError, error };
};

export default connect(mapStateToProps, { verify2fLogin, sendVerificationCode, loginApiError })(
  withTranslation()(TwostepVerification),
);
